import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Avatar, Col, Tag, Input, Icon, Tooltip, Menu, Dropdown, Table } from 'antd';
import moment from 'moment';

import { SymbolCard } from './SymbolCard';

@inject('store')
@observer
export class IndicatorTabs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            q: ''
        };
    }

    getGroups(data) {
        const types = [
            { id: 'buy', name: 'Buy' },
            { id: 'sell', name: 'Sell' },
            { id: 'dca_buy', name: 'DCA Buy' },
            { id: 'rt_sell', name: 'RT Sell' },
            { id: 'rt_buy', name: 'RT Buy' },
            { id: 'rt_final_sell', name: 'Final Sell' }
        ];

        let groups = [];
        let buy_score = 0;
        let sell_score = 0;
        for (let i = 0; i < types.length; i++) {
            const type = types[i];
            const section = data[type.id];
            if (section && section.groupResponses) {
                for (let group of section.groupResponses) {
                    groups.push({ name: group.group_name, ...group.signal, type: type.id });

                    const nextScore = group.signal.concensus / group.signal.min_concensus;
                    const isBuy = ['buy', 'dca_buy', 'rt_buy'].indexOf(type.id) >= 0;
                    if (isBuy && nextScore > buy_score) buy_score = nextScore;
                    if (!isBuy && nextScore > sell_score) sell_score = nextScore;
                }
            }
        }
        return { groups, buy_score, sell_score };
    }

    render() {
        const strat = this.props.store.botStore.indicatorStore.indicators[
            this.props.match.params.id
        ];

        const cooldown = this.props.store.botStore.indicatorStore.cooldown;

        const menu = (
            <Menu
                onClick={item => {
                    this.props.store.botStore.actionStore.execute('clear_symbol_cooldown', {
                        symbol: item.key
                    });
                }}
            >
                {Object.keys(cooldown)
                    .map(symbol => {
                        return { symbol, cooldown: cooldown[symbol] };
                    })
                    .filter(item => item.cooldown)
                    .sort((a, b) => {
                        if (a.symbol < b.symbol) return -1;
                        if (a.symbol > b.symbol) return 1;
                        return 0;
                    })
                    .map(item => {
                        return <Menu.Item key={item.symbol}>{item.symbol}</Menu.Item>;
                    })}
            </Menu>
        );

        const datasource = Object.keys(strat.coins).map(symbol => {
            const coin = strat.coins[symbol];

            return {
                symbol: symbol,
                base: coin.base,
                ...this.getGroups(coin),
                cooldown: cooldown[symbol]
            };
        });

        return (
            <Col md={19}>
                <h1>
                    {strat.name} - Last scan: {moment(strat.updated_at).fromNow()}
                </h1>

                <Input.Search
                    style={{ width: 220, marginRight: 10 }}
                    value={this.state.q}
                    onChange={e => {
                        this.setState({ q: e.target.value });
                    }}
                />

                <Dropdown.Button
                    type="primary"
                    onClick={() => {
                        Object.keys(cooldown)
                            .map(symbol => {
                                return { symbol, cooldown: cooldown[symbol] };
                            })
                            .filter(item => item.cooldown)
                            .forEach(item =>
                                this.props.store.botStore.actionStore.execute(
                                    'clear_symbol_cooldown',
                                    { symbol: item.symbol }
                                )
                            );
                    }}
                    overlay={menu}
                >
                    Clear Cooldowns
                </Dropdown.Button>
                <div style={{ marginTop: 10 }}>
                    <Table
                        size="small"
                        dataSource={datasource.filter(o => {
                            return (
                                o.base.toLocaleLowerCase().indexOf(this.state.q.toLowerCase()) >= 0
                            );
                        })}
                        rowKey={'symbol'}
                        pagination={{ defaultPageSize: 100 }}
                        expandedRowRender={record => (
                            <SymbolCard symbol={record.base} data={strat.coins[record.symbol]} />
                        )}
                        columns={[
                            {
                                title: '',
                                dataIndex: 'cooldown',
                                key: 'cooldown',
                                render: cooldown => {
                                    return cooldown ? (
                                        <Tooltip
                                            title={moment(cooldown).format('DD/MM/YYYY hh:mm:ss a')}
                                        >
                                            <Icon type="clock-circle" />
                                        </Tooltip>
                                    ) : null;
                                }
                            },
                            {
                                title: 'Symbol',
                                dataIndex: 'base',
                                key: 'base',
                                render: (text, o) => {
                                    return (
                                        <Fragment>
                                            <Avatar
                                                style={{ height: 24, width: 24 }}
                                                src={`/symbols/${text}.png`}
                                            />{' '}
                                            {text}
                                        </Fragment>
                                    );
                                }
                            },
                            {
                                title: 'Buy Groups',
                                dataIndex: 'buy_groups',
                                key: 'buy_groups',
                                defaultSortOrder: 'descend',
                                sorter: (a, b) => {
                                    return a.buy_score - b.buy_score;
                                },
                                render: (value, o) => {
                                    return o.groups
                                        .filter(group => {
                                            return (
                                                ['buy', 'dca_buy', 'rt_buy'].indexOf(group.type) >=
                                                0
                                            );
                                        })
                                        .map((group, i) => {
                                            let color = null;
                                            if (group.hasSignal) {
                                                color =
                                                    ['buy', 'dca_buy', 'rt_buy'].indexOf(
                                                        group.type
                                                    ) >= 0
                                                        ? '#48773c'
                                                        : '#f09090';
                                            }

                                            return (
                                                <Tag color={color} key={i}>
                                                    {group.name} {group.concensus}/
                                                    {group.min_concensus}
                                                </Tag>
                                            );
                                        });
                                }
                            },
                            {
                                title: 'Sell Groups',
                                dataIndex: 'sell_groups',
                                key: 'sell_groups',

                                sorter: (a, b) => {
                                    return a.sell_score - b.sell_score;
                                },
                                render: (value, o) => {
                                    return o.groups
                                        .filter(group => {
                                            return (
                                                ['buy', 'dca_buy', 'rt_buy'].indexOf(group.type) ===
                                                -1
                                            );
                                        })
                                        .map((group, i) => {
                                            let color = null;
                                            if (group.hasSignal) {
                                                color =
                                                    ['buy', 'dca_buy', 'rt_buy'].indexOf(
                                                        group.type
                                                    ) >= 0
                                                        ? '#48773c'
                                                        : '#f09090';
                                            }

                                            return (
                                                <Tag color={color} key={i}>
                                                    {group.name} {group.concensus}/
                                                    {group.min_concensus}
                                                </Tag>
                                            );
                                        });
                                }
                            }
                        ]}
                    />
                </div>
            </Col>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/IndicatorsView/IndicatorTabs.js